import store from '@Store';
import { createSelector } from 'reselect';

export function firstParameterState(fn) {
  return (...args) => fn(store.getState(), ...args);
}

export function memorizeForNg(selector) {
  const nextSelector = createSelector([selector], (result) => result && result.toJS());

  return firstParameterState(nextSelector);
}
